import React, { useEffect, useState } from 'react';
import { styled, useMediaQuery } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import theme from 'theme';
import { Colors } from 'library';

import { RecruitTopBar } from './RecruitTopBar';
import { RecruitSidebar, SIDEBAR_WIDTH, AppMode } from './RecruitSidebar';

export function RecruitLayout({ children }: { children: React.ReactNode }) {
    const small = useMediaQuery(theme.breakpoints.down('md'));
    const [sidebarOpen, setSidebarOpen] = useState(!small);
    const location = useLocation();
    const history = useHistory();

    const currentMode: AppMode = location.pathname.startsWith('/recruit') ? 'recruit' : 'subs';

    useEffect(() => {
        setSidebarOpen(!small);
    }, [small]);

    const handleModeChange = (newMode: AppMode) => {
        if (newMode === 'recruit') {
            history.push('/recruit');
        } else {
            history.push('/home');
        }
    };

    return (
        <Root>
            <RecruitTopBar small={small} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
            <RecruitSidebar
                small={small}
                open={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                mode={currentMode}
                onModeChange={handleModeChange}
            />
            <Main sidebarOpen={sidebarOpen} small={small}>
                {children}
            </Main>
        </Root>
    );
}

const Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: Colors.white,
});

const Main = styled('main')<{ sidebarOpen: boolean; small: boolean }>(({ sidebarOpen, small }) => ({
    flexGrow: 1,
    marginLeft: sidebarOpen && !small ? SIDEBAR_WIDTH : 0,
    marginTop: small ? 50 : 60,
    transition: 'margin-left 0.2s ease',
    padding: 24,
    backgroundColor: Colors.faintGrey,
    minHeight: 'calc(100vh - 60px)',
}));
